import { Box, Flex, Heading } from "@chakra-ui/react";
import WelcomeSection from "components/WelcomeSection";

interface TrackingPageLayoutProps {
  title: string;
  /** Bouton(s) aligné(s) à droite du titre (ex. Créer, Import) */
  action?: React.ReactNode;
  children: React.ReactNode;
  /** Si true, le contenu est dans une Box blanche avec borderRadius (comme Clients). Sinon seul le titre/action + children. */
  withWhiteBox?: boolean;
}

/**
 * Layout commun des pages Tracking : WelcomeSection + section avec titre (et optionnel bouton) + contenu.
 * Aligné sur la page Clients.
 */
export default function TrackingPageLayout({
  title,
  action,
  children,
  withWhiteBox = true,
}: TrackingPageLayoutProps) {
  return (
    <Flex
      gap="18px"
      bg="very_light_gray"
      flex={1}
      flexDirection="column"
      py="20px"
    >
      <WelcomeSection />
      <Flex
        flexDirection="column"
        alignItems="start"
        px={{ base: "20px", sm: "24px" }}
        minHeight="100vh"
      >
        <Flex gap="4px" alignSelf="stretch" flexDirection="column">
          <Flex
            justifyContent="center"
            alignItems="center"
            flexDirection={{ base: "column", sm: "row" }}
          >
            <Heading size="text2xl" as="h5" fontFamily="Arimo">
              {title}
            </Heading>
            {action && (
              <Flex
                pl="56px"
                pr="130px"
                gap="13px"
                flex={1}
                justifyContent="flex-end"
                alignItems="center"
                alignSelf={{ base: "stretch", sm: "auto" }}
                flexDirection={{ base: "column", sm: "row" }}
                px={{ md: 0, base: "20px" }}
              >
                {action}
              </Flex>
            )}
          </Flex>
        </Flex>
        {withWhiteBox ? (
          <Box mt="16px" bg="white" w="100%" borderRadius="10px">
            {children}
          </Box>
        ) : (
          <Box mt="16px" w="100%">
            {children}
          </Box>
        )}
      </Flex>
    </Flex>
  );
}
